const langEn = {
    selectACountry: "Select A Country",
    turkish: "Türkçe",
    english: "English",
    japanese: "JAPAN",
    settings: "Settings",
    close: "Close",
    language: "Language",
    giveUp: "Give Up",
    guess: "Guess",
    share: "Share",
    answer: "Answer",
    win: "Win",
    lose: "Lose",
    maps: "Maps",
    wiki: "Wiki",
    congratulations: "Congratulations, you have found the today's answer:",
    unfortunately: "Unfortunately, you could not find the today's answer:",
    copy: "Your result is copied to clipboard",
    nextNationleIn: "Next Nationle in ",
    hours: " hours ",
    minutes: " minutes ",
    seconds: " seconds",
    stats: "Stats",
    nextNationleIsReady: "Next Nationle is ready. Refresh the page for the next country.",
    viewCountry: "View the country on Google Maps",
    areYouGivingUp: "Are you giving up?",
    yes: "Yes",
    no: "No",
    howToPlay: "How To Play?",
    guessTheCountry: "Guess the country of the day in 6 guesses. After each guess, you will have the distance and the direction from your guess and to the target country.",
    example: "Example",
    theTarget: "The target country is 1162 km away from Azerbaijan and in the west.",
    nextGuess: "Next guess, Turkey, it's the country to guess! Congrats!",
    inspiredBy: "Inspired By",
    madeBy: "Made By",
    heavilyInspired: "Nationle has been heavily inspired by ",
    creator: "Nationle is made by ",
    youCanReach: ". You can reach the ",
    support: " If you want to support, you can buy me a ",
    sourceCode: "source code.",
    coffee: "coffee.",
    createdBy: " created by ",
    and: " and ",
    showMap: "Show the Map",
    mapDisabled: "Map and flag are hidden. You can turn it on in settings.",
    flagMode: "Flag Mode",
    azerbaijan: "Azerbaijan",
    turkey: "Turkey",
    wikiMessage: "View the country on Wikipedia",
    avgDistance: "Average Distance",
    winRate: "Win Rate",
    winStreak: "Win Streak",
    back: "Back",
    next: "Next",
    guessChart: "Guess",
    loseChart: "Lose",
    europe: "Europe",
    asia: "Asia",
    africa: "Africa",
    southAmerica: "South America",
    northAmerica: "North America",
    oceania: "Oceania"
  }
  
  export default langEn;